import React, { useState } from "react";

export const AddMusicForm = ({ userData, setUserData }) => {
	const [currentMusic, setCurrentMusic] = useState("");

	// Handle adding a music
	const addMusic = () => {
		if (currentMusic && !userData?.music?.includes(currentMusic)) {
			const updatedMusic = userData?.music ? [...userData?.music, currentMusic] : [currentMusic];
			if (updatedMusic.length > 5) {
				updatedMusic.pop(); // Remove the last music if there are more than 5
			}
			const updatedUserData = { ...userData, music: updatedMusic };
			setUserData(updatedUserData);
			setCurrentMusic(""); // Reset input
		}
	};

	// Handle removing a music
	const removemusic = (musicName) => {
		const updatedMusic = userData?.music?.filter((h) => h !== musicName);
		const updatedUserData = { ...userData, music: updatedMusic };
		setUserData(updatedUserData);
	};

	return (
		<>
			<label htmlFor="music" className="form-label">
				<i className="bi bi-music-note-beamed"></i> <span>Music</span>
			</label>
			<div className="input-group mb-2">
				<input
					className="form-control"
					value={currentMusic}
					onChange={(e) => setCurrentMusic(e.target.value)}
					maxLength={50}
					placeholder="Type your favourite musical artists..."
				/>
				<button
					className="btn my-btn d-flex align-items-center justify-content-center"
					onClick={addMusic}
					disabled={!currentMusic || userData?.music?.length >= 5}
					style={{ padding: "0", height: "38px", width: "78px" }}
				>
					<i className="bi bi-plus" style={{ fontSize: "38px" }}></i>
				</button>
			</div>

			<div>
				<ul className="list-group">
					{userData?.music?.map((music, index) => (
						<li
							key={index}
							className="list-group-item d-flex justify-content-between align-items-center"
							style={{ padding: "0 0 0 10px" }}
						>
							<div>
								<i className="bi bi-music-note-beamed me-2"></i>
								{music}
							</div>
							<button
								className="btn btn-danger btn-sm"
								onClick={() => removemusic(music)}
								style={{ padding: "0", height: "30px", width: "30px" }}
							>
								<i className="bi bi-trash"></i>
							</button>
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
